import { useEffect, useState } from "react";
import StringComparisonDropdown from "../../dropdowns/stringComparison.dropdown.advancedQuery";

const FORM_FIELDS = {
  comparison: "is",
  stringValue: "",
  caseSensitive: false,
};

const StringInput = ({ field = {}, setMatch = () => {} }) => {
  const [formFields, setFormFields] = useState(FORM_FIELDS);
  const { comparison, stringValue, caseSensitive } = formFields;

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormFields({ ...formFields, [name]: value });
  };
  const handleBooleanChange = (event) => {
    const { name, checked } = event.target;
    setFormFields({ ...formFields, [name]: checked });
  };
  useEffect(() => {
    if (comparison === "is") {
      setMatch((prevMatch) => {
        // get keys and values
        const [key, value] = Object.entries(prevMatch)[0];
        return {
          [key]: [
            ...value.map((fieldVal, i) =>
              field.value === Object.keys(fieldVal)[0]
                ? { [Object.keys(fieldVal)[0]]: stringValue }
                : fieldVal
            ),
          ],
        };
      });
    }
    if (comparison === "includes") {
      setMatch((prevMatch) => {
        const [key, value] = Object.entries(prevMatch)[0];
        return {
          [key]: [
            ...value.map((fieldVal, i) =>
              field.value === Object.keys(fieldVal)[0]
                ? {
                    [Object.keys(fieldVal)[0]]: {
                      $regex: stringValue,
                      $options: caseSensitive ? "" : "i",
                    },
                  }
                : fieldVal
            ),
          ],
        };
      });
    }
    if (comparison === "doesn't include") {
      setMatch((prevMatch) => {
        const [key, value] = Object.entries(prevMatch)[0];
        return {
          [key]: [
            ...value.map((fieldVal, i) =>
              field.value === Object.keys(fieldVal)[0]
                ? {
                    [Object.keys(fieldVal)[0]]: {
                      $not: {
                        $regex: stringValue,
                        $options: caseSensitive ? "" : "i",
                      },
                    },
                  }
                : fieldVal
            ),
          ],
        };
      });
    }
  }, [formFields]);
  return (
    <div className="justify-between bg-slate-100 p-2 flex-wrap gap-2 flex flex-row shadow shadow-secondary">
      <h3 className="font-bold">{field.label}:</h3>
      <div className="flex-wrap flex flex-row gap-2">
        <StringComparisonDropdown
          handleChange={handleChange}
          name="comparison"
          value={comparison}
        />
        <input
          type="text"
          onChange={handleChange}
          placeholder="Enter a value..."
          name="stringValue"
          value={stringValue}
          className="w-32 rounded px-2 shadow shadow-secondary"
        />
        {comparison !== "is" && (
          <div className="flex flex-row gap-2 px-2 rounded shadow shadow-secondary">
            <label>Case Sensitive:</label>
            <input
              type="checkbox"
              onChange={handleBooleanChange}
              name="caseSensitive"
              checked={caseSensitive}
              className=" checked:accent-primary "
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default StringInput;
